import axios from "axios"

const API_URL = process.env.REACT_APP_API_URL

const BASE_APPROVAL_URL = `${API_URL}/pending-logs`;
const BASE_PENDING_URL =`${API_URL}/lead_log`;

export const getLeadLogs = async (leadId: string, token: string) => {
    return axios.get(`${BASE_APPROVAL_URL}?lead_id=${leadId}`, {
        headers: { 'X-Auth-token': token }
    });
};

export const getLogsPending = async (leadLogId: string, token: string) => {
    return axios.get(`${BASE_PENDING_URL}/${leadLogId}/pending`, {
        headers: { 'X-Auth-token': token }
    });
};

export const getPendingApprovalInfo = async (leadLogId: string, pendingsId: string, token: string) => {
    return axios.get(`${BASE_PENDING_URL}/${leadLogId}/pending/${pendingsId}/approval`, {
        headers: { 'X-Auth-token': token }
    });
};

export const approveLog = async (leadLogId: string, pendingsId: string, approvalId: string, otp: string, token: string) => {
    return axios.post(
        `${BASE_PENDING_URL}/${leadLogId}/pending/${pendingsId}/approval/${approvalId}/approve/creator`,
        { otp },
        { headers: { 'X-Auth-token': token } }
    );
};

export const approveLogAsApprover = async (leadLogId: string, pendingsId: string, approvalId: string, token: string) => {
    return axios.post(
        `${BASE_PENDING_URL}/${leadLogId}/pending/${pendingsId}/approval/${approvalId}/approve/approver`,
        {},
        { headers: { 'X-Auth-token': token } }
    );
};

export const rejectLog = async (leadLogId: string, pendingsId: string, approvalId: string, token: string) => {
    return axios.post(
        `${BASE_PENDING_URL}/${leadLogId}/pending/${pendingsId}/approval/${approvalId}/reject`,
        {},
        { headers: { 'X-Auth-token': token } }
    );
};

export const resendOtp = async (leadLogId: string, pendingsId: string, approvalId: string, token: string) => {
    return axios.post(
        `${BASE_PENDING_URL}/${leadLogId}/pending/${pendingsId}/approval/${approvalId}/send-otp`,
        {},
        { headers: { 'X-Auth-token': token } }
    );
};

export const cancelLog = async (leadLogId: string, token: string) => {
    return axios.post(
        `${BASE_PENDING_URL}/${leadLogId}/cancel`,
        {},
        { headers: { 'X-Auth-token': token } }
    );
};